import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PricingPlan from "../../PricingPlan/PricingPlan";
import "./AlgoTrading-ad1.css";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import BenefitImg from "../../../../Images//landing/landing-benefit-img.png";
import EarnInterest from "../../../../Images/utilities-menu.png";
import Logo from "../../../../Images/Logo.png";
import LatestSecure from "../../../../Images/others-menu.png";
import RoundClock from "../../../../Images/partner-with-us-menu.png";
import Downloadapp from "../../../../Images/landing/landing-download-app.png";
import Playstore from "../../../../Images/playstore.png";
import Appstore from "../../../../Images/appstore.png";
import { useNavigate, useLocation } from "react-router-dom";
import LandingHeader from "../../LandingHeader/LandingHeader";
const requestIcon = <FontAwesomeIcon icon={faComment} />
const callIcon = <FontAwesomeIcon icon={faPhone} />
const facebook = <FontAwesomeIcon icon={faFacebook} />
const twitter = <FontAwesomeIcon icon={faTwitter} />
const linkedin = <FontAwesomeIcon icon={faLinkedin} />
const instagram = <FontAwesomeIcon icon={faInstagram} />

// function onChange(value) {
//     console.log("Captcha value:", value);
// }



function AlgoTradingad1() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('')
    const [showText, setShowText] = useState('');
    let pathName = window.location.pathname.split('-')[0];
    let navigate = useNavigate();
    let fullname = /[a-zA-Z][a-zA-Z ]*$/;
    var phoneno = /[0-9]$/;
    var emailvalidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    function onChange(value) {
        setShowText(value)
        //console.log("Captcha value:", value);
    }
    const Validation = (evt) => {

        if (evt.target.id == "Firstname") {
            if (fullname.test(evt.target.value)) {
                setName(evt.target.value)
                // console.log(evt.target.value)
            }

            else {
                if (evt.target.value.length < 1) {
                    setName('')
                }
                else {
                    alert("Please enter valid name")
                }

            }
        }
        else if (evt.target.name == "mobile") {
            if (phoneno.test(evt.target.value)) {
                if (evt.target.value.length < 11) {
                    setMobile(evt.target.value)
                }
                else {
                    alert("Only Enter 10 Digit");
                }
                //console.log(evt.target.value)
            }
            else {
                if (evt.target.value.length < 1) {
                    setMobile('')
                }
                else {
                    alert("Please enter valid contact number")
                }
            }

        }
        else if (evt.target.id == "email") {
            setEmail(evt.target.value.toLowerCase())
        }
    }
    const onsubmiitform = (event) => {
        event.preventDefault();
        if (name != '' && email != '' && mobile != '' && showText != '') {
            if (mobile.length == 10) {
                if (emailvalidation.test(email.toLowerCase())) {

                    const request = {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 'first_name': name, 'email': email, 'mobile': mobile, 'lpage': pathName.replace('/', ''), 'l_page': window.location.pathname.replace("/", "") })
                    }
                    fetch('https://moneysukh.com:8443/crm', request)
                        .then(response => {
                            if (response.ok) {
                                response.json().then(json => {
                                    if (json.dta.contact != undefined) {
                                        // window.location="/ThanksYou"
                                        sendMsg(request)
                                        navigate('/ThanksYou')
                                    }
                                    else {
                                        alert("email id already exists")
                                    }

                                })
                            }
                        })
                        .catch(e => {
                            //console.log(e);
                        })
                }
                else {
                    alert("Please enter valid email")
                }
            }
            else {
                alert("Please enter 10 digit")
            }

        }
        else {
            alert("Please enter the all field value")
        }

    }
    const sendMsg = (request) => {
        fetch('https://moneysukh.com:8443/res/send-mail', request)
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        //console.log(json);
                    })
                }
            })
            .catch(e => {
                // console.log(e);
            })
    }


    return (

        <>
            <LandingHeader />
            <div className="algotradingad1_page">
                {/* <div className="algotradingad1_page"> */}
                <section className="landing_header">
                    <div className="container">
                        <div className="landingheader_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingheader_logo">
                                        <a href="/"> <img className="img-fluid logoimg" src={Logo} alt="Logo" /></a>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingheader_text text-right">
                                        <a href="tel:91 9638237000" className="btn callus_header">Call US: 96382-37000</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* </div> */}
                <section className="algolandinghero_section" id="query_form">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-md-12 col-sm-12 col-xs-12">
                                <div className="algolandinghero_text">
                                    <h2>Most advance <span>Algo Trading platform</span></h2>
                                    <div class="blutext"><small>(</small> More than 100 tested strategies to select <small>)</small> </div>
                                    <PricingPlan />
                                </div>
                            </div>
                            <div className="col-xl-5 col-md-12 col-sm-12 col-xs-12">
                                <div className="landingqueryform_main">
                                    <div className="landing_queryform">
                                        <h3>Open Demat Account</h3>
                                        <form className="landing_form" onSubmit={onsubmiitform}>
                                            <div className="form-group">
                                                <label for="Firstname">Name <span class="required-mark-label">*</span></label>
                                                <input type="text" className="form-control" id="Firstname" aria-describedby="Firtname" placeholder="Name" onChange={(e) => Validation(e)} value={name} />
                                            </div>
                                            <div className="form-group">
                                                <label for="email">Email id <span class="required-mark-label">*</span></label>
                                                <input type="text" className="form-control" id="email" aria-describedby="email" placeholder="email" onChange={(e) => Validation(e)} />
                                            </div>
                                            <div className="form-group">
                                                <label for="mobile">Mobile <span class="required-mark-label">*</span></label>
                                                <input type="text" name="mobile" id="mobile" placeholder="Mobile No." onChange={Validation} value={mobile
                                                } />
                                            </div>
                                            <div className="form-group">
                                                <div className="captcha_panel text-white">
                                                    <ReCAPTCHA
                                                        sitekey="6Ld081AjAAAAAB-cDElsSSUot-5w0WtXA_XY3YrS"
                                                        onChange={onChange}
                                                    />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn btn-primary">Apply Now</button>
                                        </form>
                                        <p>For Existing Clients <a href="https://learn.moneysukh.com/existing-client/">Click Here</a>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="algolandingbenefitslist_section">
                    <Container>
                        <div className="algolandingbenefits_main">
                            <h2>BENEFITS OF ALGO TRADING</h2>
                            <div className="algolandingbenefits_grid">
                                <Row className="align-items-center">
                                    <Col xl={6} md={12} sm={12} xs={12}>
                                        <div className="algolandingbenefitslist_imgpanel">
                                            <img src={BenefitImg} alt={BenefitImg} className="img-fluid mx-auto d-block" />
                                        </div>
                                    </Col>
                                    <Col xl={6} md={12} sm={12} xs={12}>
                                        <div className="algolandingbenefitslist_group">
                                            <ul>
                                                <li>
                                                    <h3>Trend</h3>
                                                    <p>Trades are executed on the basis of popular trend</p>
                                                </li>
                                                <li>
                                                    <h3>Index rebalancing</h3>
                                                    <p>Traders tend to focus on trades that’s have rebalancing effect</p>
                                                </li>
                                                <li>
                                                    <h3>Opportunity</h3>
                                                    <p>Now track and trade the real opportunity arises in live markets</p>
                                                </li>
                                                <li>
                                                    <h3>Fast</h3>
                                                    <p>Trade execution at lightining speed</p>
                                                </li>
                                                <li>
                                                    <h3>Accuracy</h3>
                                                    <p>Trades get double checked to prevent any basic errors</p>
                                                </li>
                                                <li>
                                                    <h3>Emotions</h3>
                                                    <p>Algo makes your trading more decisive and emotions free</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </Col>

                                </Row>
                            </div>
                        </div>

                    </Container>
                </section>

                <section className="algolandingwhymoneysukh_section">
                    <div className="container">
                        <div className="landingpage_heading">
                            <h2>WHY MONEYSUKH?</h2>
                        </div>
                        <div className="row align-items-center">
                            <Col md={4}>
                                <div className="algolandingwhymoneysukh_panel">
                                    <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={EarnInterest} alt="EarnInterest" /></span>
                                    <h3>Earn Interest on ledger balance</h3>
                                    <p>Triple benefits - Get interest , trade at Rs 20 per order & free delivery brokerage</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="algolandingwhymoneysukh_panel">
                                    <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={LatestSecure} alt="LatestSecure" /></span>
                                    <h3>Latest and secure Technology</h3>
                                    <p>Cloud based & user-friendly platform with lots of scanners <small>/</small> screeners to help your trading decisions.</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="algolandingwhymoneysukh_panel">
                                    <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={RoundClock} alt="RoundClock" /></span>
                                    <h3>Round the clock support</h3>
                                    <p>24 hours support and invest with the help of dedicated research</p>
                                </div>
                            </Col>

                        </div>
                    </div>
                </section>

                <section className="landingcta_section">
                    <div className="container">
                        <div className="landingpage_heading">
                            <h2>CONNECT WITH OUR EXECUTIVE</h2>
                        </div>
                        <div className="landingcta_grid">
                            <a className="landingcta_btn" href="#query_form">
                                <span class="media">
                                    <span class="request_icon">
                                        {requestIcon}
                                    </span>
                                    <span class="media-body">Request for open your account</span>
                                </span>
                            </a>
                            <span className="or_text">OR</span>
                            <a className="landingcta_btn callon_cta" href="tel:91 9638237000">
                                <span class="media">
                                    <span class="call_icon">
                                        {callIcon}
                                    </span>
                                    <span class="media-body">Call us on : 96382-37000</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </section>

                <section className="landingdownload_section">
                    <div className="container">
                        <div className="landingdownload_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingdownload_text">
                                        <h3>Download Mobile App</h3>
                                        <p>Stable. Powerful Super – fast</p>
                                        <div className="landingdownload_appgrid">
                                            <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241"> <img className="img-fluid" src={Playstore} alt="Playstore" /></a>
                                            <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN"> <img className="img-fluid" src={Appstore} alt="Appstore" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingdownload_img text-center">
                                        <img className="img-fluid" src={Downloadapp} alt="Downloadapp" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing_footer">
                    <div className="container">
                        <div className="landingfooter_main">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="landingfooter_contact">
                                        <div class="landingpage_heading"><h2>For Any Query</h2></div>
                                        <ul className="landingfooter_nav">
                                            <li><a href="tel:96382-37000">Call us on : 96382-37000</a></li>
                                            <li><a href="mailto:sales@moneysukh.com">Email : sales@moneysukh.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingfooter_connect text-center">
                                        <div class="landingpage_heading"><h2>Connect</h2></div>
                                        <div className="landing_socialmedia">
                                            <a href="https://www.facebook.com/Moneysukh"><span>{facebook}</span></a>
                                            <a href="https://twitter.com/moneysukhonline"><span>{twitter}</span></a>
                                            <a href="https://www.linkedin.com/company/mansukh-securities-&-finance-ltd./"><span>{linkedin}</span></a>
                                            <a href="https://www.instagram.com/moneysukhofficial/"><span>{instagram}</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="landing_disclaimer text-center"><a href="/Disclaimer">Disclaimer*</a></p>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default AlgoTradingad1;